import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const VirtualConnectionLineageCountsFragmentGql: DocumentNode = gql`
fragment VirtualConnectionLineageCountsFragment on VirtualConnection {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
`;
